import "./App.css";
import "./DarkMode.css";
import "antd/dist/antd.css";
import "react-datepicker/dist/react-datepicker.css";
import Modals from "./Components/Modals/Modals";
import Routing from "./Components/Routing/Routing";
import AxiosInterceptors from "./utils/AxiosInterceptors";
import ErrorBoundary from "./Components/ErrorBoundary/ErrorBoundary.tsx";
import DismissibleToast from "./utils/DismissibleToast/DismissibleToast";
import { useEffect } from "react";
import { setDarkMode } from "./utils/utilsFuncs.js";

function App() {
  useEffect(() => {
    setDarkMode();
  }, []);

  return (
    <ErrorBoundary>
      <div id="App" className="App" style={{ height: "100%" }}>
        <AxiosInterceptors />
        <DismissibleToast />
        <Modals />
        <Routing />
      </div>
    </ErrorBoundary>
  );
}

export default App;
